import { jsx as _jsx } from "react/jsx-runtime";
import anchorme from 'anchorme';
import DOMPurification from 'dompurify';
import { memo } from 'react';
export const phoneNumberRegex = /\b(0030|\+30)?(210\d{7}|69\d{8})\b|\b1?-?\(?[0-9]{3}[\-\)][0-9]{3}-[0-9]{4}\b/gi;
// Function to truncate long URLs in the middle
const truncateUrl = (url, maxLength = 44) => {
    if (url.length <= maxLength) {
        return url;
    }
    const start = Math.ceil(maxLength * 0.6); // 60% for the beginning
    const end = Math.floor(maxLength * 0.4) - 3; // 40% for the end, minus 3 for "..."
    return `${url.substring(0, start)}...${url.substring(url.length - end)}`;
};
export const formatMessage = (message) => {
    // First, process with anchorme to detect URLs
    const processed = anchorme({
        input: message,
        options: {
            // Fixes Moveo.ai wrong url
            specialTransform: [
                {
                    test: /\bveo\.ai\b/i,
                    transform: (s) => s,
                },
            ],
            attributes: { target: '_blank', rel: 'noopener noreferrer' },
        },
        extensions: [
            // an extension for greek + usa phones
            {
                test: phoneNumberRegex,
                transform: (string) => `<a href="tel:${string}">${string}</a>`,
            },
        ],
    });
    // First, fix URLs with fragments that anchorme may have missed
    // This handles cases where the fragment ends up as plain text after the link
    const fixedFragments = processed.replace(/<a([^>]*href=["']([^"']+)["'][^>]*)>([^<]*)<\/a>(#[^\s<]*)/gi, (match, attributes, href, linkText, fragment) => {
        // Include the fragment in both the href and the link text
        const fullUrl = href + fragment;
        const displayText = linkText + fragment;
        // Update the href to include the fragment
        const updatedAttributes = attributes.replace(/href=["']([^"']+)["']/, `href="${fullUrl}"`);
        return `<a${updatedAttributes}>${displayText}</a>`;
    });
    // Post-process to truncate long URLs in anchor tags
    return fixedFragments.replace(/<a([^>]*href=["']([^"']+)["'][^>]*)>([^<]*)<\/a>/gi, (match, attributes, href, linkText) => {
        // Only truncate if the link text is the same as the href (auto-generated links)
        if (linkText === href) {
            const truncatedText = truncateUrl(href);
            // Add tooltip with full URL if the text was actually truncated
            if (truncatedText !== href) {
                return `<a${attributes} title="${href}">${truncatedText}</a>`;
            }
            return `<a${attributes}>${truncatedText}</a>`;
        }
        return match;
    });
};
export const Linkify = memo(({ children: message }) => {
    const sanitizer = DOMPurification.sanitize;
    const result = formatMessage(message);
    return (_jsx("span", { dangerouslySetInnerHTML: {
            __html: sanitizer(result),
        } }));
});
Linkify.displayName = 'Linkify';
